// 防抖
const debounce = (fn, timeout = 200) => {
  let timer;
  return function (this, ...args) {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    timer = setTimeout(() => {
      fn.apply(this, args);
    }, timeout);
  };
};

/**
 * 商卡所在页面的筛排器埋点处理
 * @param filterPanelData
 * @returns
 */
const handleFilterParams = (filterPanelData) => {
  const { sortOptions, filterOptions } = filterPanelData?.json_data || {};
  let sort_code = '';
  let sort_name = '';
  if (sortOptions && sortOptions.sortOptionValues && sortOptions.sortOptionValues.length > 0) {
    sortOptions.sortOptionValues.forEach((item) => {
      if (item.isSelected) {
        sort_code = item.sortCode;
        sort_name = item.sortName;
      }
    });
  }
  const filter_code_array: string[] = [];
  const filter_name_array: string[] = [];
  if (filterOptions) {
    filterOptions.forEach((filterOption) => {
      filterOption.filterOptionValues.forEach((item) => {
        if (item.isSelected) {
          filter_code_array.push(item.filterId);
          filter_name_array.push(item.filterDisplayName);
        }
      });
    });
  }
  const filter_code = filter_code_array.join(';');
  const filter_name = filter_name_array.join(';');
  const lxFilterParams = {
    sort_code,
    sort_name,
    filter_code,
    filter_name,
  };
  return lxFilterParams;
};

function arabicToStandardNumbers(input) {
  const arabicNumbers = '٠١٢٣٤٥٦٧٨٩'; // 东阿拉伯数字
  const standardNumbers = '0123456789'; // 标准阿拉伯数字

  let result = '';

  for (const char of input) {
    const index = arabicNumbers.indexOf(char);
    if (index !== -1) {
      result += standardNumbers[index];
    } else {
      result += char; // 如果不是阿拉伯数字，保留原字符
    }
  }

  return result;
}

function containsArabicNumbers(input) {
  const arabicNumberPattern = /[٠١٢٣٤٥٦٧٨٩]/;

  return arabicNumberPattern.test(input);
}

export {
  debounce, handleFilterParams, arabicToStandardNumbers, containsArabicNumbers
};
